<template>
  <div class="article-attachment-panel">
    <el-upload
      v-if="dialog.upload"
      style="height: 40%"
      class="upload-demo"
      drag
      action
      multiple
      :show-file-list="false"
      fullscreen="true"
      :before-remove="beforeRemove"
      :http-request="fileUpload"
      :accept="acceptAttachmentType"
      :before-upload='handleBeforeUpload'>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em style="color:#5ed5d9;">点击上传</em></div>
    </el-upload>
    <el-scrollbar :style="dialog.upload ? 'height: 60% ':'height: 100%'" ref="scrollbar">
      <div style="width: calc(100% - 10px)">
        <el-table :data="fileTable" border size="small">
          <el-table-column align="center" prop="attachmentOriginalName" label="" width="70px">
            <template slot-scope="scope">
              <i :class="scope.row.attachmentOriginalName | fileIcon(this_)"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称"></el-table-column>
          <el-table-column align="center" prop="attachmentName" label="文件别名">
            <template slot-scope="scope">
              <el-input v-model="scope.row.attachmentName"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="" label="操作" width="100">
            <template slot-scope="scope">
              <!--查看附件-->
              <el-button style="border:0px !important;" type="text" size="small" class="el-icon-download"
                         @click="preViewAttachment(scope.row,scope.$index)"></el-button>
              <!--移除附件-->
              <el-button style="border:0px !important;" type="text" size="small" class="el-icon-close"
                         @click="beforeRemove(scope.row,scope.$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import {DIALOG_TYPE_ADD,DIALOG_TYPE_VIEW,DIALOG_TYPE_UPDATE,ATTA_FILE_SUF_LIST,ATTA_FILE_SHOW_TYPE,ATTA_UPLOAD_CASE_SHARE_TYPE_STR,
  CARD_HEIGHT_TYPE,TAB_HEIGHT_TYPE,ATTA_FILE_DOWN_TYPE,PAGE_SIZE_TYPE,ATTA_UPLOAD_COMPONENT_TYPE_STR,SINGLE_ATTACHMENT_MAX_SIZE} from '@/constants/constants'

export default {
  name: "ArticleAttachmentUpload",
  data(){
    return{

      this_: this,

      dialog: {
        upload: true,
      },

      //附件的基本信息
      fileTable:[],

      //准备的颜色的数组
      attachmentColors: {
        'ppt': "#fd585e",
        'doc': "#2a83eb",
        'docx': "#2a83eb",
        'xls': "#16b881",
        'xlsx': "#16b881",
        'pdf': "#ff734c",
      },

      //附件的file对象
      attachments: [],

      acceptAttachmentType: ATTA_UPLOAD_CASE_SHARE_TYPE_STR,

      fileIconType:{
        'ppt':'icon-file-ppt-fill',
        'xls':'icon-file-excel-fill',
        'xlsx':'icon-file-excel-fill',
        'word':'icon-file-word-fill',
        'pdf':'icon-PDF',
      },
    }
  },

  filters:{
    //设置图标的颜色
    fileColor: function (arg, this_) {
      let type = arg.attachmentOriginalName.substring(arg.attachmentOriginalName.lastIndexOf('.') + 1)
      return ("color:" + this_.attachmentColors[type])
    },

    fileIcon:function (arg,this_) {
      if (arg){
        let type= arg.substring(arg.lastIndexOf('.') + 1)
        return (this_.fileIconType[type]+' iconfont')
      }
      return '';
    }
  },

  methods:{

    getAttachmentInfo(item = {}){
      item.attachments = this.attachments
      item.fileTable = this.fileTable
    },

    preViewAttachment(row, index){

    },

    beforeRemove(row, index){

    },

    fileUpload(file){
      //将附件的信息添加到讨论中
      this.fileTable.push({
        attachmentOriginalName: file.file.name
      })
      this.attachments.push(file)
    },

    handleBeforeUpload(file){
      let testMsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (!this.attaFileSuf.includes(testMsg)) {
        this.$message({
          message: '上传附件类型不合法！',
          type: 'warning',
          showClose: true
        })
        return false
      } else {
        return true
      }
    },
  }
}
</script>

<style scoped>

.article-attachment-panel {
  display: flex;
  align-content: center;
  flex-direction: column;
  padding: 20px;
}

.upload-demo{
  text-align: center;
}

i.icon-fenxiang{
  color: #29c4e4;
  font-size: 18px;
}
i.icon-file-ppt-fill{
  color: #ff7082;
  font-size: 40px;
}
i.icon-file-word-fill{
  color: #008dfa;
  font-size: 40px;
}
i.icon-PDF{
  color: #eb5e5e;
  font-size: 40px;
}
i.icon-file-excel-fill{
  color: #00c090;
  font-size: 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/article/ArticleAttachmentUpload.vue